import { render, staticRenderFns } from "./TabInfo.vue?vue&type=template&id=e2009fe8&"
import script from "./TabInfo.vue?vue&type=script&lang=js&"
export * from "./TabInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports